import { useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCards } from 'swiper/modules'
import type { Swiper as SwiperType } from 'swiper'
// @ts-ignore
import 'swiper/css'
// @ts-ignore
import 'swiper/css/effect-cards'
import './index.css'

interface CardSwiperProps {
  cards: CardInfoResponse[]
  onCardChange?: (cardId: number, index: number) => void
  getCardImage?: (card: CardInfoResponse, index: number) => string
}

export default function CardSwiper({ cards, onCardChange, getCardImage }: CardSwiperProps) {
  const swiperRef = useRef<SwiperType | null>(null)

  const handleSlideChange = (swiper: SwiperType) => {
    const newIndex = swiper.activeIndex
    
    if (onCardChange && cards[newIndex]?.id) {
      onCardChange(cards[newIndex].id!, newIndex)
    }
  }

  return (
    <div className="card-swiper-container">
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper
        }}
        effect="cards"
        grabCursor={true}
        modules={[EffectCards]}
        onSlideChange={handleSlideChange}
        className="card-swiper"
        cardsEffect={{
          perSlideOffset: 8,
          perSlideRotate: 2,
          slideShadows: false,
        }}
      >
        {cards.map((card, index) => {
          const cardImageSrc = getCardImage ? getCardImage(card, index) : '/images/card/wpay-electronic.png'
          
          return (
            <SwiperSlide key={card.id}>
              <div className="card-item">
                <img 
                  className="w-full h-full block object-cover" 
                  src={cardImageSrc} 
                  alt={`Card ${index + 1}`}
                />
              </div>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}
